module.exports = __webpack_public_path__ + "img/trophy-full.ab496934.svg";